/**
 * 浏览器端入口
 */
import 'library';
import React, { Component } from 'react'
import PropTypes from 'prop-types';
import Index from './index';
import ReactDOM from 'react-dom';

ReactDOM.render((
    <Index />
), document.getElementById('application-root')
);



// WEBPACK FOOTER //
// ./_source/cqsx/pages/cqsx/client.js